package com.anjuros.website.templates.template8.modules

import com.anjuros.website.templates.template8.util.ResKey


data class PubMenuItem(
    val index:Int,
    val name: ResKey,
    val price: String,
    val description: ResKey,
    val vegetarian: Boolean = false,
    val glutenFree: Boolean = false
)

enum class Template8MenuItem(
    val category: ResKey,
    val items: List<PubMenuItem>
) {
    STARTERS(
        category = ResKey.TEMPLATE8_PRODUCT_SECTION1,
        items = listOf(
            PubMenuItem(
                index = 0,
                name = ResKey.TEMPLATE8_SECTION1_PRODUCT1_TITLE,
                price = "6.50",
                description = ResKey.TEMPLATE8_SECTION1_PRODUCT1_DESC,
                vegetarian = true,
                glutenFree = false
            ),
            PubMenuItem(
                index = 1,
                name = ResKey.TEMPLATE8_SECTION1_PRODUCT2_TITLE,
                price = "5.50",
                description = ResKey.TEMPLATE8_SECTION1_PRODUCT2_DESC,
                vegetarian = true,
                glutenFree = true
            ),
            PubMenuItem(
                index = 2,
                name = ResKey.TEMPLATE8_SECTION1_PRODUCT3_TITLE,
                price = "7.00",
                description = ResKey.TEMPLATE8_SECTION1_PRODUCT3_DESC,
                vegetarian = false,
                glutenFree = true
            )
        )
    ),

    MAINS(
        category = ResKey.TEMPLATE8_PRODUCT_SECTION2,
        items = listOf(
            PubMenuItem(
                index = 0,
                name = ResKey.TEMPLATE8_SECTION2_PRODUCT1_TITLE,
                price = "12.00",
                description = ResKey.TEMPLATE8_SECTION2_PRODUCT1_DESC,
                vegetarian = false,
                glutenFree = false
            ),
            PubMenuItem(
                index = 1,
                name = ResKey.TEMPLATE8_SECTION2_PRODUCT2_TITLE,
                price = "14.50",
                description = ResKey.TEMPLATE8_SECTION2_PRODUCT2_DESC,
                vegetarian = false,
                glutenFree = true
            ),
            PubMenuItem(
                index = 2,
                name = ResKey.TEMPLATE8_SECTION2_PRODUCT3_TITLE,
                price = "11.50",
                description = ResKey.TEMPLATE8_SECTION2_PRODUCT3_DESC,
                vegetarian = true,
                glutenFree = false
            )
        )
    ),

    DESSERTS(
        category = ResKey.TEMPLATE8_PRODUCT_SECTION3,
        items = listOf(
            PubMenuItem(
                index = 0,
                name = ResKey.TEMPLATE8_SECTION3_PRODUCT1_TITLE,
                price = "6.00",
                description = ResKey.TEMPLATE8_SECTION3_PRODUCT1_DESC,
                vegetarian = true,
                glutenFree = false
            ),
            PubMenuItem(
                index = 1,
                name = ResKey.TEMPLATE8_SECTION3_PRODUCT2_TITLE,
                price = "4.50",
                description = ResKey.TEMPLATE8_SECTION3_PRODUCT2_DESC,
                vegetarian = true,
                glutenFree = true
            ),
            PubMenuItem(
                index = 2,
                name = ResKey.TEMPLATE8_SECTION3_PRODUCT3_TITLE,
                price = "5.50",
                description = ResKey.TEMPLATE8_SECTION3_PRODUCT3_DESC,
                vegetarian = false,
                glutenFree = true
            )
        )
    );
}